module.exports = __webpack_public_path__ + "img/completed.04526448.svg";